export default __webpack_public_path__ + "static/media/AQUIS.8397006f.svg";